@if (sesion.autenticado()) {
  <div class="creatio-studio-shell">
    <!-- =====================================================================
         BARRA SUPERIOR INTEGRADA EN EL DEGRADADO AMBIENTAL (42px) — NEXAMED
         ===================================================================== -->
    <header class="cs-topbar">
      <div class="cs-topbar-left">
        <a class="cs-wordmark" (click)="irAModulo(modulosMenu[0])" style="cursor: pointer;">NexaMed CRM</a>

        <button type="button" class="cs-circle-btn" title="Ir al Escritorio Médico de Procesos" (click)="irAModulo(modulosMenu[2])">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
            <polygon points="6 4 20 12 6 20 6 4"/>
          </svg>
        </button>

        <button type="button" class="cs-circle-btn" title="Registrar nuevo caso clínico" (click)="crm.modalNuevoCaso.set({ abierto: true })">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
        </button>

        <form class="cs-top-search" (ngSubmit)="ejecutarBusquedaGlobal()">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
            <circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>
          </svg>
          <input
            type="search"
            name="q"
            placeholder="Buscar paciente o documento..."
            [(ngModel)]="busquedaGlobal"
          />
        </form>
      </div>

      <div class="cs-topbar-right">
        <button type="button" class="cs-top-icon" title="Resumen Ejecutivo" (click)="irAModulo(modulosMenu[0])">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
            <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
          </svg>
        </button>

        <button type="button" class="cs-top-icon" title="Monitor de Colas SLA" (click)="irAModulo(modulosMenu[5])">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 22a2 2 0 0 0 2-2h-4a2 2 0 0 0 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4a1.5 1.5 0 0 0-3 0v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
          </svg>
        </button>

        <button type="button" class="cs-top-icon" title="Registrar nuevo paciente" (click)="crm.modalNuevoPaciente.set(true)">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
            <path d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
          </svg>
        </button>

        <button type="button" class="cs-top-icon" title="Cerrar sesión" (click)="sesion.cerrarSesion()">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
        </button>

        <div class="cs-user-avatar" [title]="sesion.usuario()?.nombre || 'Pedro Herrera'">
          <span>{{ inicialesUsuario() }}</span>
          <span class="cs-online-dot"></span>
        </div>
      </div>
    </header>

    <!-- =====================================================================
         CUERPO PRINCIPAL: SIDEBAR 100% FUNCIONAL + LIENZO NEXAMED
         ===================================================================== -->
    <div class="cs-body-frame">
      <aside class="cs-left-sidebar">
        <div class="cs-side-top">
          <!-- Buscador que filtra en vivo los módulos del menú lateral -->
          <div class="cs-side-search">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>
            </svg>
            <input
              type="search"
              placeholder="Buscar módulo..."
              [ngModel]="filtroModulo()"
              (ngModelChange)="filtroModulo.set($event)"
            />
          </div>

          <!-- Selector desplegable funcional de categorías de módulos -->
          <div class="cs-apps-dropdown-wrap">
            <button
              type="button"
              class="cs-all-apps-row"
              (click)="menuCategoriasAbierto.set(!menuCategoriasAbierto())"
            >
              <span>{{ etiquetaCategoriaActual() }}</span>
              <span>{{ menuCategoriasAbierto() ? '▴' : '▾' }}</span>
            </button>

            @if (menuCategoriasAbierto()) {
              <div class="cs-apps-dropdown-menu">
                <button type="button" [class.active]="categoriaModulo() === 'todos'" (click)="seleccionarCategoriaMenu('todos')">
                  Todos los módulos (10)
                </button>
                <button type="button" [class.active]="categoriaModulo() === 'clinica'" (click)="seleccionarCategoriaMenu('clinica')">
                  Clínica y Cirugía (5)
                </button>
                <button type="button" [class.active]="categoriaModulo() === 'atencion'" (click)="seleccionarCategoriaMenu('atencion')">
                  Atención y Pacientes (2)
                </button>
                <button type="button" [class.active]="categoriaModulo() === 'omnicanal'" (click)="seleccionarCategoriaMenu('omnicanal')">
                  Omnicanal y Tiempos (3)
                </button>
              </div>
            }
          </div>
        </div>

        <nav class="cs-nav-list" aria-label="Navegación NexaMed">
          @for (mod of modulosFiltrados(); track mod.id) {
            <button
              type="button"
              class="cs-nav-link"
              [class.active-highlight]="esModuloActivo(mod)"
              (click)="irAModulo(mod)"
            >
              <span class="cs-icon-box" [attr.data-color]="mod.color">
                @switch (mod.id) {
                  @case ('inicio') {
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
                    </svg>
                  }
                  @case ('casos') {
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>
                    </svg>
                  }
                  @case ('escritorio') {
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                    </svg>
                  }
                  @case ('quirurgicos') {
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/>
                    </svg>
                  }
                  @case ('pacientes') {
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"/>
                    </svg>
                  }
                  @case ('colas') {
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"/>
                    </svg>
                  }
                  @case ('chats') {
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"/>
                    </svg>
                  }
                  @case ('convenios') {
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
                    </svg>
                  }
                  @case ('biometria') {
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
                    </svg>
                  }
                  @default {
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"/>
                    </svg>
                  }
                }
              </span>
              <span>{{ mod.etiqueta }}</span>
            </button>
          } @empty {
            <div style="padding: 12px; font-size: 11px; color: rgba(255,255,255,0.6);">
              Sin módulos con "{{ filtroModulo() }}"
            </div>
          }
        </nav>

        <!-- Barra inferior blanca de pestañas abiertas 100% funcional -->
        <div class="cs-bottom-dock">
          @for (tab of pestanasAbiertas(); track tab.id) {
            <div
              class="cs-dock-tab"
              [class.active]="esModuloActivo(tab)"
              [class.muted]="!esModuloActivo(tab)"
              (click)="irAModulo(tab)"
            >
              <span class="cs-dock-dot" [attr.data-color]="tab.color"></span>
              <span class="cs-dock-lbl">{{ tab.etiqueta }}</span>
              <span class="cs-dock-x" title="Cerrar pestaña" (click)="cerrarPestanaDock(tab, $event)">×</span>
            </div>
          }
        </div>
      </aside>

      <!-- LIENZO INTERIOR CON ESQUINA SUPERIOR IZQUIERDA REDONDEADA -->
      <main class="cs-rounded-workspace">
        <router-outlet />
      </main>
    </div>
  </div>
} @else {
  <router-outlet />
}

<!-- Modal: + Nuevo caso -->
@if (crm.modalNuevoCaso().abierto) {
  <div class="modal-backdrop" (click)="cerrarModalCaso()">
    <div class="modal-card" (click)="$event.stopPropagation()">
      <div class="modal-hd">
        <div>
          <div style="font-size: 15px; font-weight: 700; color: var(--ink);">Registrar nuevo caso clínico</div>
          <div class="m">Se asignará al proceso y etapa seleccionados con trazabilidad completa</div>
        </div>
        <button type="button" class="modal-close" (click)="cerrarModalCaso()">✕</button>
      </div>
      <div class="modal-body">
        <div class="form-row">
          <label class="m">Proceso de Ebenezer</label>
          <select class="modal-input" [ngModel]="casoEmbudoId" (ngModelChange)="alCambiarEmbudoModal($event)">
            @for (e of embudos(); track e.id) {
              <option [value]="e.id">{{ e.nombre }}</option>
            }
          </select>
        </div>

        <div class="form-row">
          <label class="m">Etapa inicial del recorrido</label>
          <select class="modal-input" [(ngModel)]="casoEtapaId">
            @for (et of etapasEmbudoModal(); track et.id) {
              <option [value]="et.id">{{ et.orden }}. {{ et.nombre }}</option>
            }
          </select>
        </div>

        <div class="form-row">
          <label class="m">Paciente</label>
          <select class="modal-input" [(ngModel)]="casoContactoId">
            @for (c of contactos(); track c.id) {
              <option [value]="c.id">{{ c.nombres }} {{ c.apellidos }} ({{ c.tipoDocumento || 'CC' }} {{ c.numeroDocumento || 'Sin doc' }})</option>
            }
          </select>
        </div>

        <div class="form-row">
          <label class="m">Procedimiento / Solicitud oftalmológica</label>
          <input class="modal-input" type="text" placeholder="Ej. Facoemulsificación + Lente Trifocal OD" [(ngModel)]="casoTitulo" />
        </div>

        <div class="form-row">
          <label class="m">Red social / Canal de ingreso</label>
          <select class="modal-input" [(ngModel)]="casoOrigen">
            <option value="whatsapp">WhatsApp Business (Chat DM)</option>
            <option value="instagram">Instagram (DM / Comentario en Reel o Post)</option>
            <option value="messenger">Facebook & Messenger (DM / Comentario en Post)</option>
            <option value="tiktok">TikTok (DM / Comentario en Video)</option>
            <option value="youtube">YouTube (Comentario en Video / Short)</option>
            <option value="google">Google Maps / Mi Negocio (Reseña / Pregunta)</option>
            <option value="pbx">Línea PBX</option>
            <option value="web">Portal Web</option>
            <option value="manual">Atención Presencial</option>
          </select>
        </div>

        @if (errorModal()) {
          <div class="modal-error">{{ errorModal() }}</div>
        }
      </div>
      <div class="modal-ft">
        <button type="button" class="btn" (click)="cerrarModalCaso()">Cancelar</button>
        <button type="button" class="btn pri" (click)="guardarNuevoCaso()">Crear caso</button>
      </div>
    </div>
  </div>
}

<!-- Modal: + Paciente con Autocompletado Clínico -->
@if (crm.modalNuevoPaciente()) {
  <div class="modal-backdrop" (click)="cerrarModalPaciente()">
    <div class="modal-card" (click)="$event.stopPropagation()">
      <div class="modal-hd">
        <div>
          <div style="font-size: 15px; font-weight: 700; color: var(--ink);">Ficha de nuevo paciente</div>
          <div class="m">Paciente único por documento dentro de Centro Oftalmológico Ebenezer</div>
        </div>
        <button type="button" class="modal-close" (click)="cerrarModalPaciente()">✕</button>
      </div>
      <div class="modal-body">
        <div style="display: grid; grid-template-columns: 100px 1fr auto; gap: 8px; align-items: end;">
          <div class="form-row">
            <label class="m">Tipo doc.</label>
            <select class="modal-input" [(ngModel)]="pacTipoDoc">
              <option value="CC">CC</option>
              <option value="TI">TI</option>
              <option value="CE">CE</option>
              <option value="PA">PA</option>
              <option value="PPT">PPT</option>
            </select>
          </div>
          <div class="form-row">
            <label class="m">Número de documento</label>
            <input class="modal-input" type="text" placeholder="Prueba con 45123987 o 73456120" [(ngModel)]="pacNumeroDoc" />
          </div>
          <button
            type="button"
            class="btn"
            style="height: 36px; font-size: 11.5px; color: var(--blue); border-color: #BBD4F2; background: var(--blue-soft);"
            [disabled]="consultandoClinica()"
            (click)="autocompletarDesdeClinica()"
          >
            {{ consultandoClinica() ? 'Buscando...' : 'Traer de Clínica' }}
          </button>
        </div>

        @if (avisoClinico()) {
          <div class="clinica-banner">{{ avisoClinico() }}</div>
        }

        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
          <div class="form-row">
            <label class="m">Nombres</label>
            <input class="modal-input" type="text" [(ngModel)]="pacNombres" />
          </div>
          <div class="form-row">
            <label class="m">Apellidos</label>
            <input class="modal-input" type="text" [(ngModel)]="pacApellidos" />
          </div>
        </div>

        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
          <div class="form-row">
            <label class="m">Teléfono / WhatsApp</label>
            <input class="modal-input" type="text" placeholder="+57 300..." [(ngModel)]="pacTelefono" />
          </div>
          <div class="form-row">
            <label class="m">Red social / Canal principal</label>
            <select class="modal-input" [(ngModel)]="pacOrigen">
              <option value="whatsapp">WhatsApp Business</option>
              <option value="instagram">Instagram (DM / Comentario)</option>
              <option value="messenger">Facebook & Messenger</option>
              <option value="tiktok">TikTok</option>
              <option value="youtube">YouTube</option>
              <option value="google">Google Maps / Reseñas</option>
              <option value="pbx">PBX</option>
              <option value="web">Web</option>
              <option value="manual">Presencial</option>
            </select>
          </div>
        </div>

        <div class="form-row">
          <label class="m">Correo electrónico</label>
          <input class="modal-input" type="email" [(ngModel)]="pacCorreo" />
        </div>

        <label class="consent-box">
          <input type="checkbox" [(ngModel)]="pacConsentimiento" />
          <span>Titular autoriza el tratamiento de datos personales y clínicos (Ley 1581 de 2012)</span>
        </label>

        @if (errorModal()) {
          <div class="modal-error">{{ errorModal() }}</div>
        }
      </div>
      <div class="modal-ft">
        <button type="button" class="btn" (click)="cerrarModalPaciente()">Cancelar</button>
        <button type="button" class="btn pri" (click)="guardarNuevoPaciente()">Guardar paciente</button>
      </div>
    </div>
  </div>
}
